import PropTypes from 'prop-types'
/* eslint react/no-find-dom-node: 0 */

import React, { Component } from 'react'
import styles from './_modal.css'
import classnames from 'classnames'
import ReactDOM from 'react-dom'

export class ModalMask extends Component {

  static propTypes = {
    enter: PropTypes.bool,
    exit: PropTypes.bool,
    onRequestedClose: PropTypes.func,
    children: PropTypes.node,
    effect: PropTypes.string,
    shouldScroll: PropTypes.bool,
  }

  handleClick = (evt) => {
    evt.stopPropagation()
  }

  render () {
    const { enter, exit, effect, shouldScroll, onRequestedClose } = this.props
    const stateClasses = classnames({
      [styles.enter]: enter,
      [styles.exit]: exit,
      [styles.scrollable]: shouldScroll,
    })
    const maskClassName = classnames(styles.mask, styles[effect], stateClasses)
    const contentClassName = classnames(styles.content, styles[effect], stateClasses)

    return (
      <div className={maskClassName} onClick={onRequestedClose}>
        <div className={contentClassName} onClick={this.handleClick}>
          {this.props.children}
        </div>
      </div>
    )
  }

}

export default class Modal extends Component {

  static propTypes = {
    onRequestedClose: PropTypes.func,
    onAfterOpen: PropTypes.func,
    onAfterClose: PropTypes.func,
    isOpen: PropTypes.bool,
    closeTimeout: PropTypes.number,
    children: PropTypes.node,
    shouldCloseOnMaskClick: PropTypes.bool,
    shouldCloseOnEscKey: PropTypes.bool,
    shouldScroll: PropTypes.bool,
    shouldFocus: PropTypes.bool,
    enterTimeout: PropTypes.number,
    preventBodyScroll: PropTypes.bool,
  }

  static defaultProps = {
    effect: 'smooth',
    closeTimeout: 250,
    enterTimeout: 250,
    shouldFocus: true,
    shouldScroll: false,
    shouldCloseOnEscKey: true,
    shouldCloseOnMaskClick: true,
    preventBodyScroll: true,
  }

  state = {
    isOpen: false,
    enter: false,
    exit: false,
  }

  componentWillMount () {
    if (this.props.isOpen) {
      this.open()
    }
  }

  componentWillReceiveProps (nextProps) {
    if ('isOpen' in nextProps) {
      if (!this.props.isOpen && nextProps.isOpen) { this.open() }
      if (this.props.isOpen && !nextProps.isOpen) { this.close() }
    }
  }

  componentWillUnmount () {
    this._timeouts.forEach((i) => window.clearTimeout(i))
    this.allowBodyScroll()
  }

  _timeouts = []

  preventBodyScroll () {
    if (!document) { return }
    const body = document.querySelector('body')
    body.style.overflow = 'hidden'
    body.style.position = 'fixed'
  }

  allowBodyScroll () {
    if (!document) { return }
    const body = document.querySelector('body')
    body.style.overflow = 'auto'
    body.style.position = 'static'
  }

  scrollToTop () {
    const node = ReactDOM.findDOMNode(this.mask)
    if (node) { node.scrollTop = 0 }
  }

  focus () {
    const mask = ReactDOM.findDOMNode(this.mask)

    if (mask) {
      const child = mask.firstChild()
      if (child) {
        child.setAttribute('tabindex', '0')
        child.focus()
        child.setAttribute('tabindex', '-1')
      }
    }
  }

  open = () => {
    const {
      preventBodyScroll,
      shouldScroll,
      shouldFocus,
      shouldCloseOnEscKey,
      enterTimeout,
    } = this.props

    if (preventBodyScroll) {
      this.preventBodyScroll()
    }

    if (shouldFocus) {
      this._timeouts.push(setTimeout(this.focus, enterTimeout))
    }

    if (shouldScroll) {
      this._timeouts.push(setTimeout(this.scrollToTop, enterTimeout))
    }

    if (shouldCloseOnEscKey) {
      window.addEventListener('keydown', this.handleKeyDown)
    }

    this.setState({ isOpen: true }, () => {
      this._timeouts.push(setTimeout(() => {
        this.setState({ exit: false, enter: true }, this.props.onAfterOpen)
      }, 40))
    })
  }

  close = () => {
    const { preventBodyScroll, shouldCloseOnEscKey } = this.props

    this.setState({ enter: false, exit: true })

    if (preventBodyScroll) {
      this.allowBodyScroll()
    }

    if (shouldCloseOnEscKey) {
      window.removeEventListener('keydown', this.handleKeydown)
    }

    this._timeouts.push(setTimeout(() => {
      this.setState({ isOpen: false, exit: false }, this.props.onAfterClose)
    }, this.props.closeTimeout))
  }

  handleClickMask = () => {
    const { shouldCloseOnMaskClick, onRequestedClose } = this.props
    if (shouldCloseOnMaskClick && onRequestedClose) {
      onRequestedClose()
    }
  }

  handleKeyDown = (evt) => {
    const { shouldCloseOnEscKey, onRequestedClose } = this.props
    if (evt.which === 27 && shouldCloseOnEscKey && onRequestedClose) {
      onRequestedClose()
    }
  }

  render () {
    const { children } = this.props
    const { isOpen } = this.state

    return (
      <div className={styles.portal}>
        {isOpen ?
          <ModalMask
            {...this.props}
            {...this.state}
            onRequestedClose={this.handleClickMask}
            ref={(c) => { this.mask = c }}
          >
            {children}
          </ModalMask>
        : null}
      </div>
    )
  }

}
